import { useEffect } from "react";
import {
    applyHeadTags,
    clearManagedHeadTags,
    mapJsonLdToHeadTags,
    SITE_MANAGED_ATTR,
    getSiteMeta,
    buildOrganizationJsonLd,
    buildWebSiteJsonLd,
} from "@utilities";

/**
 * Emits the site-wide Organization + WebSite JSON-LD once for the whole app.
 * Uses a dedicated head scope (`data-rh-site`) so per-page `PageHead` re-applies
 * never clear it. Mounted once near the app root. Renders nothing.
 */
export const SiteJsonLd = () => {
    useEffect(() => {
        const site = getSiteMeta();
        const tags = mapJsonLdToHeadTags([
            buildOrganizationJsonLd(site),
            buildWebSiteJsonLd(site),
        ]);
        applyHeadTags(tags, document, SITE_MANAGED_ATTR);
        return () => clearManagedHeadTags(document, SITE_MANAGED_ATTR);
    }, []);

    return null;
};
